<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>

<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">Principal</h1>
      <ul>
        <li><a class="active" href="/">Home</a></li>
        <li>
          <a>About</a>
        </li>
        <li>Principal</li>
      </ul>
    </div>
  </div>

  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70 representative-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <about-menu></about-menu>
        </div>

        <div class="col-lg-8">
          <section class="profile-section orange-color">
            <div class="container">
              <div class="row clearfix">
                <!-- Image Section -->
                <div class="image-column col-lg-5 md-mb-50">
                  <div class="inner-column mb-50 md-mb-0">
                    <div class="image">
                      <img src="assets/college/principal.jfif" alt="D.VENKATA SIVA REDDY" class="img-fluid" />
                    </div>
                    <div class="team-content text-center">
                      <h3>D.VENKATA SIVA REDDY</h3>
                      <h5> M.Com., M.Ed</h5>
                      <h5>Principal</h5>
                    </div>
                  </div>
                </div>
                <!-- Content Section -->
                <div class="content-column col-lg-7 md-pl-15 md-pt-0">
                  <div class="inner-column">
                    
                    <p>
                      D.Venkata Siva Reddy is the Principal of SDRR degree & PG College. As the principal of SDRR Degree College he has been responsible for achieving many milestones in the successful journey of SDRR Degree College. He is the guiding spirit for all the staff and students in SDRR Degree College. He is the total 15 years of experience in teaching and administration..
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->
